import { useTranslation } from "react-i18next";
import { NubImageUpload, RowInfo } from "../../common";
import { BackgroundModal } from "../modals";

const BackgroundVideo = ({ useQuery }) => {
  const { t } = useTranslation();

  return (
    <>
      <p dangerouslySetInnerHTML={{__html: t(`Require the player to submit a video. <br>An AI will remove the background and swap in the provided background.`)}} />
      <RowInfo help={<BackgroundModal />} isFull>
        <NubImageUpload
            label={t("Photo to put in the background")}
            name="overlay"
            useQuery={useQuery}
            storageMode="legacy"
          />
      </RowInfo>
    </>
  );
};

/** @deprecated Use NubImageUpload for builder image upload controls. */
export default BackgroundVideo;
